import React, { useEffect, useState } from 'react'
import { collection, getDocs } from 'firebase/firestore'
import { db } from '../../firebase/firebase'

const MOBILE_BP = 600

export const BibleOfTheDay = ({ overlay = false }) => {
  const [verse, setVerse] = useState(null)
  const [visible, setVisible] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BP)
  const lang = localStorage.getItem('userLanguage') || 'ua'

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < MOBILE_BP)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  useEffect(() => {
    getDocs(collection(db, 'verses')).then(snap => {
      const list = snap.docs.map(d => d.data())
      if (list.length) setVerse(list[Math.floor(Math.random() * list.length)])
    }).catch(() => {})
  }, [])

  // trigger fade-in after verse is ready and painted
  useEffect(() => {
    if (!verse) return
    const t = setTimeout(() => setVisible(true), 60)
    return () => clearTimeout(t)
  }, [verse])

  if (!verse) return null

  const text = lang === 'en' ? (verse.textEn || verse.text) : verse.text
  const ref  = lang === 'en' ? (verse.referenceEn || verse.reference) : verse.reference

  if (overlay) {
    const wrapStyle = isMobile
      ? s.overlayWrapMobile
      : s.overlayWrapDesktop

    const boxStyle = {
      ...s.overlayBox,
      ...(isMobile ? s.overlayBoxMobile : {}),
      opacity: visible ? 1 : 0,
      transition: 'opacity 3s ease',
    }

    return (
      <div style={wrapStyle}>
        <div style={boxStyle}>
          <div style={s.mark}>"</div>
          <p style={s.overlayText}>{text}</p>
          <div style={s.overlayRef}>— {ref}</div>
        </div>
      </div>
    )
  }

  return (
    <div style={s.wrap}>
      <div style={s.mark}>"</div>
      <p style={s.text}>{text}</p>
      <div style={s.ref}>{ref}</div>
    </div>
  )
}

const s = {
  /* ── Overlay wrap: desktop = bottom-right corner ─────────────────────── */
  overlayWrapDesktop: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    padding: '0 24px 24px',
    pointerEvents: 'none',
  },
  /* ── Overlay wrap: mobile = full-width centered ───────────────────────── */
  overlayWrapMobile: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
    pointerEvents: 'none',
  },

  /* ── Overlay box shared ───────────────────────────────────────────────── */
  overlayBox: {
    background: 'rgba(18, 8, 3, 0.62)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    borderRadius: '18px',
    padding: '28px 34px',
    maxWidth: '360px',
    width: '100%',
    textAlign: 'center',
    border: '1px solid rgba(196, 152, 106, 0.35)',
    boxShadow: '0 12px 40px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.07)',
  },
  overlayBoxMobile: {
    maxWidth: '100%',
    padding: '22px 20px',
  },

  overlayText: {
    color: '#f5ede3',
    fontSize: '17px',
    fontStyle: 'italic',
    fontFamily: 'Georgia, "Times New Roman", serif',
    lineHeight: '1.7',
    margin: '0 0 14px',
    textShadow: '0 2px 8px rgba(0,0,0,0.6)',
    letterSpacing: '0.2px',
  },
  overlayRef: {
    color: '#c4986a',
    fontSize: '12px',
    fontWeight: '700',
    letterSpacing: '1.8px',
    textTransform: 'uppercase',
    fontFamily: '"Segoe UI", system-ui, sans-serif',
    textShadow: '0 1px 5px rgba(0,0,0,0.5)',
  },

  /* ── Standalone (fallback) mode ───────────────────────────────────────── */
  wrap: {
    textAlign: 'center',
    padding: '4px 16px 24px',
    maxWidth: '640px',
    margin: '0 auto',
  },
  mark: {
    fontSize: '56px',
    lineHeight: '0.6',
    color: 'rgba(196, 152, 106, 0.75)',
    marginBottom: '10px',
    fontFamily: 'Georgia, serif',
  },
  text: {
    fontSize: '19px',
    lineHeight: '1.65',
    color: '#2d1f14',
    fontStyle: 'italic',
    fontFamily: 'Georgia, "Times New Roman", serif',
    textShadow: '0px 1px 0px #ddd',
    margin: '0 0 14px',
  },
  ref: {
    fontSize: '14px',
    fontWeight: '700',
    color: '#c4986a',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    fontFamily: '"Segoe UI", system-ui, sans-serif',
  },
}
